(() => {
  if (window.__x7ReviewFrenchTranslations) return;
  window.__x7ReviewFrenchTranslations = true;
  const script = document.currentScript;
  const section = document.querySelector('[id^="shopify-section-template--"][id$="__reviews"]');
  if (!section) return;
  const normalize = value => value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  let translations;
  function install() {
    if (!translations) return;
    section.querySelectorAll('.jdgm-rev[data-review-id]').forEach(card => {
      if (card.querySelector('.x7-fr-review-tools')) return;
      const entry = translations.entries[card.dataset.reviewId];
      if (!entry) return;
      const title = card.querySelector('.jdgm-rev__title');
      const body = card.querySelector('.jdgm-rev__body');
      if (!body || normalize(title?.innerText || '') !== normalize(entry.source.title) || normalize(body.innerText) !== normalize(entry.source.body)) return;
      const tools = document.createElement('div'); tools.className = 'x7-fr-review-tools';
      const label = document.createElement('span'); label.textContent = 'Traduction française'; label.className = 'x7-fr-review-label';
      const button = document.createElement('button'); button.type = 'button'; button.className = 'x7-fr-review-toggle';
      const content = document.createElement('div');content.className = 'x7-fr-review-content';content.lang = 'fr';content.id = 'x7-fr-review-' + card.dataset.reviewId;
      if (entry.fr.title) {const h = document.createElement('h4');h.textContent = entry.fr.title;content.append(h);}
      const paragraph = document.createElement('div');paragraph.className = 'x7-fr-review-body';paragraph.textContent = entry.fr.body;content.append(paragraph);
      const originalTitleHidden = title?.hidden; const originalBodyHidden = body.hidden;
      let showFrench = true;
      function render() {
        if (title) title.hidden = showFrench ? true : originalTitleHidden;
        body.hidden = showFrench ? true : originalBodyHidden;
        content.hidden = !showFrench;
        button.textContent = showFrench ? 'Voir l’original' : 'Voir la traduction française';
        button.setAttribute('aria-expanded', String(showFrench));
      }
      button.setAttribute('aria-controls', content.id);button.addEventListener('click', () => {showFrench = !showFrench;render();});
      tools.append(label,button);const anchor = title || body;anchor.before(tools,content);render();
    });
  }
  fetch(script.dataset.translationsUrl, {credentials:'same-origin'}).then(response => {if(!response.ok)throw new Error('Translation file unavailable');return response.json();}).then(data => {
    translations = data;install();let scheduled = false;
    new MutationObserver(() => {if(!scheduled){scheduled = true;requestAnimationFrame(() => {scheduled = false;install();});}}).observe(section,{childList:true,subtree:true});
  }).catch(() => { /* The original reviews remain visible if the translation file cannot load. */ });
})();